import React from 'react';

import { Button, Flex } from '@sopranodesign/pulse-components';

import { useConditional } from '../hooks/index';
import AddConditionalButton from './AddConditionalButton';

const ConditionalActions = () => {
  const { valid } = useConditional();

  return (
    <Flex right xSpace>
      <AddConditionalButton />
      <Button disabled={!valid} type="submit" variant="primary">
        Save
      </Button>
    </Flex>
  );
};

export default ConditionalActions;
